module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Intake",
            "field": "intake",
            "optionListApiUrl": '/contracts_intake/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Scholarship",
            "field": "scholarship_id",
            "optionListApiUrl": '/scholarships/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Year",
            "field": "year",
            "optionListApiUrl": '/contracts_year/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Date",
            "field": "milestone_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Amount",
            "field": "milestone_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a457ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Milestone/Detail.vue
// module id = 692
// module chunks = 1